<template>
  <div id="backToIngredients">
    <a :href="urlPath" style="display: block">
      <div class="research_thumbnail_container">
        <img alt="Ingredients" src="/CKFinderJava/userfiles/images/2021/DK/Ingredienser-thumbnail-v2.jpg" />
        <span class="btn-research-corner">{{ this.$root.language.wsm_backToOverview.toUpperCase() }}</span>
      </div>
    </a>
  </div>
</template>

<script>
  export default {
    name: 'BackToIngredients',
    computed: {
      urlPath: function() {
        var urlSection = window.location.pathname.split('/');
        return window.location.origin + basedir + '/' + urlSection.at(-3);
      }
    }
  }
</script>


<style lang="scss" scoped>
  #backToIngredients {
    border-radius: 4px;
    margin-bottom: 30px;
  }
  #backToIngredients:hover {
    box-shadow: 0 0 20px 4px #cacaca;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
  }

  #backToIngredients:hover img {
    opacity: 0.8;
    transition: all 0.3s ease-in-out;
  }
  #backToIngredients:hover .btn-research-corner {
    transform: scale(1.07);
     transition: all 0.3s ease-in-out;
  }
  .research_thumbnail_container {
    position: relative;
    text-align: center;
    height: 282px;
    overflow: hidden;
    border-radius: 4px;
    img {
      max-width: 100%; 
      margin-top: -127px !important;
    }
  }
  .research_thumbnail_container .research_thumbnail_container .text {
    position: absolute;
    top: 20px;
    left: 0;
    right: 0;
    width: 300px;
    margin: 0 auto;
    padding: 15px 5px;
    font-size: 18px;
  }
  .research_thumbnail_container .btn-research-corner {
    position: absolute;
    top: 127px;
    left: 0;
    right: 0;
    width: 60%;
    max-width: 180px;
    text-align: center;
    margin: 0 auto;
    transition: transform .3s;
  }
  .btn-research-corner {
    background-color: #004570;
    padding: 6px 15px !important;
    font-size: 13px;
    border-radius: 3px;
    color: white;
    border: none;
    font-weight: bold;
  }
  @media only screen and (min-width: 700px) {
    .product-left-box {
      width: 27%;
      min-width: 180px;
    }
    .research_thumbnail_container img {
      max-height: 500px;
    }
    .research_thumbnail_container .text {
      top: 59px;
      width: 70%;
    }
    .research_thumbnail_container .btn-research-corner {
      text-align: center;
    }
  }
</style>